/* eslint-disable import/prefer-default-export */
export const sortingByChoices = [
  { value: 'booking', label: 'Most Booked' },
  { value: 'price-lo-hi', label: 'Price Low - High' },
  { value: 'price-hi-lo', label: 'Price High - Low'},
];

export const timeOfDayChoices = [
  { value: 'morning', label: 'Morning (before 12 pm)' },
  { value: 'afternoon', label: 'Afternoon (after 12 pm)' },
  { value: 'evening', label: 'Evening (after 5 pm)' },
];

export const timeOfDayChoiceValues = timeOfDayChoices.map(choice => choice.value);

export const sortTimeOfDay = time => timeOfDayChoiceValues.filter(choiceValue => !!time.find(value => value === choiceValue));
